(function () {
  // The store's actual color filter is Shopify's structured taxonomy attribute
  // (filter.v.t.shopify.color-pattern) — its values are TaxonomyValue GIDs, not
  // color name strings, so we can't match the GID directly against our color
  // labels. Instead, read the human-readable label Dawn already renders next
  // to whichever swatch checkbox is checked (e.g. "Black", "Blue", "Navy").
  function getActiveColorLabel() {
    var checked = document.querySelector(
      'input[name="filter.v.t.shopify.color-pattern"]:checked'
    );
    if (!checked) return null;
    var li = checked.closest('li');
    var labelEl = li && li.querySelector('.facet-checkbox__text-label');
    return labelEl ? labelEl.textContent.trim() : null;
  }

  // Shopify's color-pattern filter uses broad buckets ("Black"), while our
  // color labels are the more specific seller-provided names ("Black
  // Leather"), so match by substring rather than exact equality.
  function findMatchingUrl(colorMedia, activeLabel) {
    if (!activeLabel) return null;
    var target = activeLabel.toLowerCase();
    for (var key in colorMedia) {
      if (key.toLowerCase().indexOf(target) !== -1) return colorMedia[key];
    }
    return null;
  }

  function applySwap() {
    var activeLabel = getActiveColorLabel();
    document.querySelectorAll('img[data-color-media]').forEach(function (img) {
      // Snapshot the original src/srcset once, before any mutation, so we can
      // always revert cleanly when the filter is cleared or doesn't match.
      if (img.dataset.defaultSrc === undefined) {
        img.dataset.defaultSrc = img.src;
        img.dataset.defaultSrcset = img.srcset || '';
      }

      var colorMedia;
      try {
        colorMedia = JSON.parse(img.getAttribute('data-color-media'));
      } catch (e) {
        return;
      }

      var url = findMatchingUrl(colorMedia, activeLabel);
      if (url) {
        img.srcset = '';
        img.src = url;
      } else {
        img.src = img.dataset.defaultSrc;
        img.srcset = img.dataset.defaultSrcset;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applySwap);

  // Dawn's facet filtering replaces #ProductGridContainer's innerHTML via an
  // AJAX fetch (see FacetFiltersForm.renderProductGridContainer in facets.js)
  // and does not fire any event we can listen for, so observe the container
  // directly and re-apply after every filter change.
  var grid = document.getElementById('ProductGridContainer');
  if (grid) {
    new MutationObserver(applySwap).observe(grid, { childList: true, subtree: true });
  }

  // ── Mobile color-filter fix (v4) ────────────────────────────────────────────
  // Two prior attempts tried to make the color swatch participate in Dawn's
  // own mobile AJAX submission path (FacetFiltersForm.onSubmitHandler /
  // createSearchParams / onSubmitForm) and neither held up under real-device
  // testing on iOS Safari, even though the underlying theory checked out
  // against the source. Confirmed the same failure reproduces on Shopify's
  // own unmodified official Dawn demo store, so this is a genuine bug
  // somewhere in Dawn's internal handling of swatch-type filters on mobile —
  // not something specific to this theme's customizations — but the exact
  // mechanism wasn't fully pinned down by static analysis alone.
  //
  // Rather than depending on that internal machinery at all, we now bypass it
  // entirely: snippets/facets.liquid was updated to put Shopify's own
  // pre-built, already-reliable toggle URLs (the same value.url_to_add /
  // value.url_to_remove used by the "clear filter" chips elsewhere on this
  // page) directly on each mobile swatch input as data-url-to-add /
  // data-url-to-remove. On tap we just read the right one and navigate there
  // — a real page load, not an AJAX re-render, so it can't be broken by
  // whatever is wrong with Dawn's mobile swatch submission logic.
  // Temporary diagnostic readout — only active with ?swatchdebug=1 in the
  // URL, so normal visitors never see it. Shows exactly which events fire
  // and why (or why not) a tap navigates, since the failure so far has only
  // reproduced on a real iPhone and not in any automated/emulated test.
  // Safe to delete this block and its two call sites once the bug is fixed.
  var SWATCH_DEBUG = /[?&]swatchdebug=1\b/.test(window.location.search);
  var debugBox;
  function debugLog(msg) {
    if (!SWATCH_DEBUG) return;
    if (!debugBox) {
      debugBox = document.createElement('div');
      debugBox.style.cssText =
        'position:fixed;left:0;right:0;bottom:0;max-height:40vh;overflow:auto;' +
        'background:rgba(0,0,0,0.85);color:#0f0;font:11px/1.4 monospace;' +
        'padding:8px;z-index:999999;white-space:pre-wrap;';
      document.body.appendChild(debugBox);
    }
    var line = document.createElement('div');
    line.textContent = new Date().toISOString().slice(11, 23) + ' ' + msg;
    debugBox.appendChild(line);
    debugBox.scrollTop = debugBox.scrollHeight;
  }

  function activateSwatch(row, input, e, via) {
    debugLog(via + ' fired on row, input id="' + input.id + '"');

    var url = input.checked
      ? input.getAttribute('data-url-to-remove')
      : input.getAttribute('data-url-to-add');
    debugLog('  -> input.checked=' + input.checked + ' url=' + url);
    if (!url) {
      debugLog('  -> no url on input, aborting');
      return;
    }

    e.preventDefault();
    if (SWATCH_DEBUG) {
      // Don't actually navigate while debugging — a real navigation would
      // wipe this log before it could be read. Log what WOULD have
      // happened instead so the log stays on screen.
      debugLog('  -> WOULD navigate to ' + url + ' (navigation suppressed, debug mode)');
      return;
    }
    debugLog('  -> navigating to ' + url);
    window.location.href = url;
  }

  function bindMobileSwatchLinks() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) {
      debugLog('bindMobileSwatchLinks: #FacetFiltersFormMobile not found');
      return;
    }

    // The clickable color circle in swatch-input.liquid is wrapped in
    // <label class="swatch-input__label">, but that label only wraps the
    // circle itself — the readable "Blue (56)" text next to it is rendered
    // separately by facets.liquid's text_value capture as a SIBLING, not a
    // descendant of the label. A real tap naturally lands on that larger,
    // more visible text (confirmed via on-device debug logging — every
    // real tap produced closest-swatch-label=false), which was never wired
    // to anything, which is why the color filter alone requires a
    // pixel-precise tap on a 24x24 circle to do anything at all. Bind to
    // the whole row (the wrapping div.swatch-input-wrapper's parent, which
    // contains both the circle and the text) instead, matching how every
    // other mobile filter type already makes its entire row tappable.
    var wrappers = form.querySelectorAll('.swatch-input-wrapper');
    debugLog('bindMobileSwatchLinks: found ' + wrappers.length + ' swatch wrapper(s)');

    wrappers.forEach(function (wrapper) {
      var row = wrapper.parentElement;
      if (!row || row.dataset.amznSwatchBound) return;
      row.dataset.amznSwatchBound = '1';

      var input = wrapper.querySelector('input.swatch-input__input');
      if (!input) return;

      // A real finger tap on iOS Safari does not reliably synthesize a
      // 'click' event on this row (confirmed via WebKit touch-event
      // testing — a programmatic .click() navigates fine, but a genuine
      // touchstart/touchend tap does not), so 'click' alone silently misses
      // every real tap. Bind 'touchend' directly instead — it's the actual
      // event a tap generates — and preventDefault it so the browser
      // doesn't also fire its usual synthesized click afterward and
      // double-navigate. 'click' stays bound too, as the path for anything
      // that isn't a touchscreen (trackpad/mouse in responsive/dev mode).
      row.addEventListener('touchend', function (e) {
        if (!e.changedTouches || e.changedTouches.length === 1) {
          activateSwatch(row, input, e, 'touchend');
        }
      });
      row.addEventListener('click', function (e) {
        activateSwatch(row, input, e, 'click');
      });
    });
  }

  bindMobileSwatchLinks();
  document.addEventListener('DOMContentLoaded', bindMobileSwatchLinks);
  debugLog('script loaded, readyState=' + document.readyState);

  // Catch-all, independent of our per-label bindings above: logs the actual
  // target of every touchend/click anywhere on the page while debug mode is
  // on, so if our bindings above aren't the problem, we can see what is
  // (wrong element receiving the tap, event not reaching us at all, etc.).
  if (SWATCH_DEBUG) {
    document.addEventListener(
      'touchend',
      function (e) {
        var t = e.target;
        debugLog(
          'GLOBAL touchend target=' + (t && t.tagName) +
          ' class="' + (t && t.className) + '"' +
          ' closest-bound-row=' + !!(t && t.closest && t.closest('[data-amzn-swatch-bound]'))
        );
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        debugLog(
          'GLOBAL click target=' + (t && t.tagName) +
          ' class="' + (t && t.className) + '"'
        );
      },
      true
    );
  }

  var mobileFacetsWrapper = document.getElementById('FacetsWrapperMobile');
  if (mobileFacetsWrapper) {
    new MutationObserver(bindMobileSwatchLinks).observe(mobileFacetsWrapper, {
      childList: true,
      subtree: true,
    });
  }
})();
